const buyRite = {
  workDone: [
      'Created over 20+ content pages from Figma designs into fully functional web pages.',
      'Implemented webhooks via Klaviyo to address real-time data synchronization in Node by creating HTTP POST requests to trigger automated actions and send notifications, enabling third-parties to subscribe to message events.',
      'Identified critical user interaction data gaps in GTM dataLayer by configuring GTM tags using JavaScript with PHP scripts to capture key events, resulting in improved data accuracy and informed decision-making for the client.',
      'Minimized cart abandonments by reducing steps required to complete a purchase, and enhancing user experience, resulting in increased checkout completion rates and improved revenue.',
  ],
  tech: [
      'Magento 2',
      'PHP',
      'LESS',
      'jQuery',
      'Docker',
      'CI/CD',
      'AWS',
      'MS SQL',
      'GTM',
      'Klaviyo',
      'Figma',
  ],
  liveLink: 'https://www.buyritebeauty.com/',
  features : [
      {
          title: 'Account Dashboard',
          image: { link: require('./buyRiteAssests/account-dashboard.png').default }
      },
      {
          title: 'Cart Page',
          image: { link: require('./buyRiteAssests/cart.png').default }
      },
      {
          title: 'Categories Page',
          image: { link: require('./buyRiteAssests/category-page.png').default }
      },
      {
          title: 'Product Detail Page',
          image: { link: require('./buyRiteAssests/pdp.png').default }
      },
      {
          title: 'Checkout',
          image: { link: require('./buyRiteAssests/checkout.png').default }
      },
      {
          title: 'Free Design & Layout Service',
          image: { link: require('./buyRiteAssests/fdls.png').default }
      },
  ],
}

export default buyRite
